export default {
  'meta': {
    'langName': 'FRANCAIS',
    'lang': 'Français'
  },
  'title': 'RAPPEL PRODUIT PANIER DE BASKET B900 BOX NBA TARMAK',
  'description': '​Nous avons identifié un risque de chute verticale du poteau sur notre panier de basket B900 s\'il est utilisé sans sa manivelle et manipulé. \nPour votre sécurité, arrêtez immédiatement toute utilisation sans sa poignée de réglage de hauteur installée dessus. \nUne mise en sécurité de votre produit sera possible avec une procédure simple et un kit qui vous sera livré gratuitement. \nCe site internet dédié à ce rappel est en cours de construction. Il vous guidera dans la marche à suivre pour faire cette opération. \nNous vous informerons dès qu\'il sera disponible (courant juillet)',
  'status': 'Translation validated by SPORT'
} as const
